<template>
  <v-row v-if="productData" justify="space-between">
    <img
      :src="`${productData.clientImage}`"
      v-show="productData.clientImage"
      height="80"
      width="200"
    />
  </v-row>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ClientLogo',
  props: {
    color: {
      type: String,
      default: 'white', // green, green--outline, white
      required: false,
    },
    strokeWidth: {
      type: Number,
      default: 50,
      required: false,
    },
    width: {
      type: Number,
      default: 100,
      required: false,
    },
    height: {
      type: Number,
      default: 50,
      required: false,
    },
    isExperience: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      productData: null,
      errored: false,
      loading: true,
      isLogoAvailable: false,
      baseUrl: process.env.VUE_APP_API_URL,
    }
  },
  mounted() {
    axios
      .get(
        this.isExperience
          ? `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/experience/${this.$route.params.experienceUUID}`
          : `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/product/${this.$route.params.productUUID}`
      )
      .then((response) => {
        this.productData = response.data
        // axios
        //   .get(`${this.productData.clientImage}`)
        //   .then(() => {
        //     this.isLogoAvailable = true
        //   })
        //   .catch(() => {
        //     this.isLogoAvailable = false
        //   })
      })
      .catch((error) => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))
  },
}
</script>

<style lang="css" scoped>
.baseColor {
  fill: #454655;
  stroke: none;
}

.green--outline {
  fill: #354258;
  stroke: #61ffab;
}

.white {
  fill: mintcream;
  stroke: none;
}
</style>
